module.exports = __webpack_public_path__ + "fonts/poppins-bolditalic-webfont.e3527232.woff2";